import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import LoadingScreen from "./commons/LoadingScreen";

const UnauthRoutes = () => {
  const { isAuth, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return isAuth ? <Navigate to="/" /> : <Outlet />;
};

export default UnauthRoutes;
